import Button from '@components/buttons/Button'
import { HeaderPage } from '@components/index'
import InputStampFile from '@components/inputs/InputStamp'
import { useYupValidation } from '@hooks/index'
import { CONFIGURATION_TYPE } from '@interfaces/configurations/enums/configurationType'
import { errorHandler } from '@services/index'
import ConfigurationService from '@services/requests/configurationService'
import configSchema, { IConfigSchema } from '@yupSchemas/configurations/configurationSchema'
import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

export default function ConfigurationPage(): React.ReactElement {
    const acceptedFiles = 'image/jpeg, image/png'
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = React.useState(false)
    const [defaultFile, setDefaultFile] = React.useState<File | string | null>(null)

    const { handleSubmit, setValue } = useForm<IConfigSchema>({
        resolver: useYupValidation(configSchema),
        defaultValues: {
            configName: CONFIGURATION_TYPE.STAMP_FILE,
            file: null
        }
    })

    async function submit(values: IConfigSchema): Promise<void> {
        setIsLoading(true)
        const formDataStamp = new FormData()
        formDataStamp.append('name', values.file?.name || 'stamp')
        formDataStamp.append('configName', CONFIGURATION_TYPE.STAMP_FILE)
        formDataStamp.append('file', values.file as File)
        try {
            if (!values.file) {
                await ConfigurationService.deleteFile(CONFIGURATION_TYPE.STAMP_FILE)
                toast('Configuração deletada com sucesso!', { type: 'success' })
            }
            else {
                await ConfigurationService.createUpdate(formDataStamp)
                toast('Configuração salva com sucesso!', { type: 'success' })
            }
        } catch (err) {
            toast(errorHandler(err).message, { type: 'error' })
        } finally {
            setIsLoading(false)
        }
    }

    async function handleDefaultFile(): Promise<void> {
        setIsLoading(true)
        try {
            const response = await ConfigurationService.getFileByConfigType(CONFIGURATION_TYPE.STAMP_FILE)
            setDefaultFile(response.signedUrl)
        } catch (err) {
            throw errorHandler(err)
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        handleDefaultFile()
    }, [])

    return (
        <div className="card">
            <div className="configurations">
                <div className='box-header'>
                    <HeaderPage title="Configurações" />
                </div>

                <form onSubmit={handleSubmit(submit)}>
                    <div className='box-header' />
                    <div className='box-inputs'>
                        <h6 className='input-title'>Selo tabela selecionados</h6>
                        <div className='file-box' >
                            <InputStampFile
                                name='stamp'
                                defaultFile={defaultFile}
                                onChange={(value) => setValue('file', value)}
                                acceptFiles={acceptedFiles}
                                isLoadingFile={isLoading}
                            />
                        </div>
                    </div>

                    <div className={'box-buttons'}>
                        <Button type="button" secondary placeholder={'Cancelar'} onClick={() => navigate('/imoveis')} />
                        <Button type="submit" placeholder={'Salvar'} isLoading={isLoading} />
                    </div>
                </form>
            </div>
        </div >
    )
}
